import React, { useState, useEffect } from 'react';
import axios from 'axios';
import GradeLevel from './GradeLevel';
import SummaryTabUser from './SummaryTabUser';

function Dashboard({ user, discipline = 'stem', readOnly }) {
  const [activeTab, setActiveTab] = useState('grades');
  const [activeGrade, setActiveGrade] = useState(0);
  const [evidence, setEvidence] = useState([]);
  const [grades, setGrades] = useState(null); // Start as null so we know when API has loaded
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [discipline]);

  const loadData = async () => {
    try {
      setLoading(true);
      const gradebandRes = await axios.get('/outcomes/api/objectives-hierarchy', { 
        params: { discipline },
        timeout: 5000, 
        withCredentials: true 
      });
      
      setGrades(gradebandRes.data);
      
      const evidenceRes = await axios.get('/outcomes/api/evidence', { 
        params: { discipline },
        timeout: 5000, 
        withCredentials: true 
      });
      setEvidence(evidenceRes.data);
    } catch (error) {
      console.error('[Dashboard] API FAILED:', error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  if (loading || !grades) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  if (grades.length === 0) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-content">
          <div className="empty-state">
            <p>This discipline has no grade levels available. Check back later or contact an administrator.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <div className="tabs">
          <button
            className={`tab ${activeTab === 'grades' ? 'active' : ''}`}
            onClick={() => setActiveTab('grades')}
          >
            Grade Levels
          </button>
          <button
            className={`tab ${activeTab === 'summary' ? 'active' : ''}`}
            onClick={() => setActiveTab('summary')}
          >
            Summary
          </button>
        </div>

        {activeTab === 'grades' ? (
          <>
            <div className="tabs">
              {grades.map((grade, index) => (
                <button
                  key={grade.id}
                  className={`tab ${activeGrade === index ? 'active' : ''}`}
                  onClick={() => setActiveGrade(index)}
                >
                  {grade.title.split(':')[0]}
                </button>
              ))}
            </div>

            <div className="grade-content">
              <GradeLevel
                grade={grades[activeGrade]}
                user={user}
                classes={[]}
                evidence={evidence}
                discipline={discipline}
                onEvidenceChange={loadData}
                readOnly={readOnly}
              />
            </div>
          </>
        ) : (
          <SummaryTabUser grades={grades} evidence={evidence} discipline={discipline} />
        )}
      </div>
    </div>
  );
}

export default Dashboard;